<div class="row">
  <div class="col-12">
    <div class="content-header">Resource Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="resourceForm">
                  <fieldset class="form-group">
                    <label for="content">content </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="content"
                      [(ngModel)]="resource.content"
                      id="content"
                      placeholder="Enter  content"
                      [ngClass]="{
                        'is-invalid': resourceSubmitted && rf.content.invalid,
                        'is-valid': resourceSubmitted && !rf.content.invalid
                      }"
                      required
                      #content
                    />
                    <div
                      *ngIf="
                        rf.content.touched &&
                        (rf.content.invalid || rf.content.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> content is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <!-- <label for="categary">Document Banner</label> -->
                    <!-- <img
                      *ngIf="!pdfUrl"
                      [src]="imageUrl + resource.documents"
                      alt=""
                      width="100px"
                      height="100px"
                    />
                    <img
                      *ngIf="pdfUrl"
                      [src]="pdfUrl"
                      alt=""
                      width="100px"
                      height="100px"
                    /> -->
                    <!-- <embed [src]="docsUrl + resource.documents" /> -->
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="Documents">Documents</label>
                    <input
                      type="file"
                      class="form-control"
                      formControlName="documents"
                      required
                      (change)="onSelectFilePdf($event)"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Read For</label>
                    <ng-select
                        [items]="readFor_list"
                        bindLabel="name"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        placeholder="Select Read For"
                        [(ngModel)]="selected_readFor"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getReadForId($event)">
                      </ng-select>
                  </fieldset>
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="resourceForm">
                  <fieldset class="form-group">
                    <label for="description">Description </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="description"
                      [(ngModel)]="resource.description"
                      id="description"
                      placeholder="Enter description"
                      #description
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="categary">Image Banner</label>
                    <img
                      *ngIf="!imgUrl"
                      [src]="imageUrl + resource.image"
                      alt=""
                      width="100px"
                      height="100px"
                    />
                    <img
                      *ngIf="imgUrl"
                      [src]="imgUrl"
                      alt=""
                      width="100px"
                      height="100px"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="Image">Image</label>
                    <input
                      type="file"
                      class="form-control"
                      formControlName="image"
                      required
                      (change)="onSelectFile($event)"
                    />
                  </fieldset>
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      (click)="submit()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
